import linkViewModel from '@vimcar/mvvm/linkViewModel'
import Paragraph from '@vimcar/shared-components/components/Paragraph'
import * as React from 'react'

import type { ViewState } from '../Root/viewModel'
import type { ViewModel } from './viewModel'

import BottomActions from '../BottomActions'
import StepContent from '../StepContent'
import mkViewModel from './viewModel'

type Props = {
  state: ViewState
  viewModel: ViewModel
}

const CustomCloseAndOrderNow = ({ state, viewModel }: Props) => (
  <React.Fragment>
    <StepContent>
      <Paragraph variant='subtitle1'>{state.currentNode.text}</Paragraph>
      <Paragraph variant='body2'>{state.currentNode.subtext}</Paragraph>
    </StepContent>
    {/* @ts-expect-error@2322 */}
    <BottomActions extraButtons={viewModel.buttons} showBack />
  </React.Fragment>
)

const component = linkViewModel(mkViewModel, CustomCloseAndOrderNow)
component.displayName = 'CustomCloseAndOrderNow'
export default component
